import ReligionType from './ReligionType.page';

export default ReligionType;
